<template>
  <b-card>
    <!-- form -->
    <b-form class="mt-2">
      <b-row>
        <b-col sm="12" class="mb-1">
          <h4>Mass Update Sisa Cuti</h4>
        </b-col>
        

        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-1 mr-1"
            @click="download()"
          >
            Download Data Sisa Cuti
          </b-button>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Upload File">
            <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              :state="file !== null"
            ></b-form-file>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Upload File" style="color: white;">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="info"
              class="mr-1"
              @click="simpanData()"
            >
              Simpan
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BFormFile, BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  exportSisaCuti,
  importSisaCuti,
} from '@/connection-api/pengajuan-cuti/api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { download } from '../../../connection-api/helpers';

export default {
  components: {
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
  },
  directives: {
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      profileFile: null,
      reloadImg: 0,
      biodata: {},
      file: [],
    }
  },
  mounted() {
    
  },
  methods: {
    async download() {
      try {
        const response = await exportSisaCuti(this.filter);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Get the current date and time
        const now = new Date();
        const timestamp = now.getFullYear() + 
                          ('0' + (now.getMonth() + 1)).slice(-2) + 
                          ('0' + now.getDate()).slice(-2) + 
                          '_' + 
                          ('0' + now.getHours()).slice(-2) + 
                          ('0' + now.getMinutes()).slice(-2) + 
                          ('0' + now.getSeconds()).slice(-2);

        // Set the filename with the timestamp
        link.setAttribute('download', `Data Sisa Cuti - ${timestamp}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up
      } catch (error) {
        console.error('Failed to download file:', error);
      }
    },
    renderImage() {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.userData.foto = reader.result;
        this.reloadImg += 1
      });
      reader.readAsDataURL(this.profileFile);
    },
    onFileSelected(event) {
      this.profileFile = event.target.files[0];
      this.renderImage();
    },
    async simpanDataOLD() {
      importSisaCuti(this.file)
      .then(response => {
        if (response.data.success == true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data Berhasil Disimpan',
            },
          })
          this.getUserUUID()
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data User Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
    },
    simpanData() {
      if(this.file != null)
        {
          importSisaCuti(this.file, 'user', event => {
          var progress = Math.round((100 * event.loaded) / event.total)
        })
          .then(response => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Import Sisa Cuti E-Cuti',
                icon: 'EditIcon',
                variant: 'success',
                text: 'Data Berhasil Disimpan',
              },
            })
          })
        .catch(error => console.log(error));
      }
    }
  },
}
</script>
